<template>
  <footer class="footer text-center py-2">
    <p class="mb-3">
      <a href="https://vt.edu/about/acceptable-use.html">Acceptable Use</a> |
      <a href="https://vt.edu/privacy.html">Privacy Statement</a> |
      <b-link id="lnk-to-help" to="/help">Help</b-link>
    </p>
    <div class="small">
      <span id="appVersion">{{ version }}</span>
      <span id="copyright"> &copy; {{ currentYear }} Virginia Polytechnic Institute and State University</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    version() {
      return this.$store.state.appVersion;
    },
  },

};
</script>

<style scoped>
  .footer {
    background-color: hsla(35, 13%, 20%, 1.0);
    color: white;
    margin-top: auto;
  }

  .footer a {
    color: white;
  }

  .footer a:hover {
    color: white;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue